// @flow
import request from 'superagent'
import { getCurrentTimestamp } from 'er2_web_utils'
import * as typesMap from 'catena/er2_map_userlayers/js/constants/action_types'
import { collaborationIsEnabled } from './collaboration'
import * as types from '../constants/action_types'
import * as wsTypes from '../modules/websockets/server/constants/action_types'

/**
 * When the map extent is changed, sync this with the server
 */
export const updateCurrentView = (view: {
    center: Array<number>,
    mapScale: number,
    resolution: number,
    rotation: number,
}) => (dispatch, getState, { emit }) => {
    const payload = {
        applicationId: getState().meta.name,
        timestamp: getCurrentTimestamp(),
        operation: {
            name: types.OT_UPDATE_MAP_VIEW,
            params: {
                ...view,
            },
        },
    }
    if (collaborationIsEnabled(getState()) && !getState().collaborationSettings.readOnly && getState().collaboration.sharedState.propagateMapView) {
        payload.roomId = getState().collaboration.sharedState.token
        emit(wsTypes.WS_CLIENT_ACTION, payload)
    }

    dispatch({ type: typesMap.UPDATE_MAP_VIEW, mapView: view })
}

/**
 * Click on "Realizations" in map popup for a cell.
 * @param lonlat
 * @returns {function(*, *, {emit: *})}
 */
export const onClickRealizations = (lonlat: [number, number]) => (dispatch, getState, { emit }) => {
    const payload = {
        applicationId: getState().meta.name,
        timestamp: getCurrentTimestamp(),
        operation: {
            name: types.OT_CLICK_REALIZATIONS,
            params: {
                lonlat,
            },
        },
    }
    if (collaborationIsEnabled(getState()) && !getState().collaborationSettings.readOnly && getState().collaboration.sharedState.propagateRealizationsClick) {
        payload.roomId = getState().collaboration.sharedState.token
        emit(wsTypes.WS_CLIENT_ACTION, payload)
    }
}

export const handledClickMap = () => ({ type: types.HANDLED_CLICK_MAP })
export const handledClickRealizations = () => ({ type: types.HANDLED_CLICK_REALIZATIONS })

/**
 * When the user clicks on the map, sync this with the server
 */
export const onSingleClick = clickEvt => (dispatch, getState, { emit }) => {
    const payload = {
        applicationId: getState().meta.name,
        timestamp: getCurrentTimestamp(),
        operation: {
            name: types.OT_CLICK_MAP,
            params: {
                ...clickEvt,
            },
        },
    }
    if (collaborationIsEnabled(getState()) && !getState().collaborationSettings.readOnly && getState().collaboration.sharedState.propagateMapClicks) {
        payload.roomId = getState().collaboration.sharedState.token
        emit(wsTypes.WS_CLIENT_ACTION, payload)
    }
}

export const onReceivePointData = location => ({ type: types.SET_POINT_DATA, location })

export const lookupPoint = (coordinate, lonlat, ficusNode, interval) => (dispatch: Function) => {
    let location = { lonlat, coordinate }
    dispatch(onReceivePointData(location))
    request.post('/er2_ficus/lookupPoint/')
        .send({
            point: lonlat,
            ficusNode,
            interval,
            returnRealizations: false,
        })
        .then((ret) => {
            location = { ...ret.body, lonlat, coordinate }
            dispatch(onReceivePointData(location))

            // Update content with longer-running realization info
            request.post('/er2_ficus/lookupPoint/')
                .send({
                    point: lonlat,
                    ficusNode,
                    interval,
                    returnRealizations: true,
                    sortRealizations: false,
                })
                .then((ret1) => {
                    dispatch(onReceivePointData({ ...location, ...ret1.body }))
                }, (ret1) => {
                    console.error(ret1)
                })
        })
}

export const updateMapLocation = (location, newState) => ({ type: types.UPDATE_MAP_LOCATION, location, newState })
